module.exports = __webpack_public_path__ + "static/media/table-retina.0826fd8a.png";